/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @typedef {object} ModelSchema
 * @property {string} type
 */

/**
 * @typedef {object} SchemaState
 * @property {ModelSchema[]} all
 */

/**
 * @type {SchemaState}
 */
export const schemaState = {
    all: [],
};
